import React, { useEffect, useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { withInject } from '@piwikpro/platform';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { Organization } from './Organization';

const mapStateToProps = (state: { session: SessionState }) => ({
  jwt: state.session?.jwt,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  organization: Organization
}

interface Props extends ReduxProps, InjectedProps {}

export const OrganizationDetailsPanel: React.FC<Props> = ({
  jwt,
  organization,
}) => {
  // flag to prevent loading organization details multiple times on JWT refresh
  const loadedRef = useRef(false);


  useEffect(() => {
    if (jwt && !loadedRef.current) {
      organization.fetchDetails().catch(() => {});
      loadedRef.current = true;
    }
  }, [jwt, organization]);

  return null;
};

export default connector(withInject<InjectedProps>({
  organization: 'OrganizationCrate.organization',
})(OrganizationDetailsPanel));
